import {
  PermissionKeys,
  PermissionTypes,
} from 'src/@smartmanufacturing/common/enum';
import { Permission } from './permission';

export class ApplicationPermission {
  // departments defined permissions
  public static DEPARTMENTS_ACCESS: Permission = {
    PermissionKey: PermissionKeys.Departments,
    PermissionType: PermissionTypes.IsRead,
  };
  public static DEPARTMENTS_CREATE: Permission = {
    PermissionKey: PermissionKeys.Departments,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static DEPARTMENTS_UPDATE: Permission = {
    PermissionKey: PermissionKeys.Departments,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static DEPARTMENTS_ACTIVATE: Permission = {
    PermissionKey: PermissionKeys.Departments,
    PermissionType: PermissionTypes.IsActivate,
  };
  public static DEPARTMENTS_DEACTIVATE: Permission = {
    PermissionKey: PermissionKeys.Departments,
    PermissionType: PermissionTypes.IsDeactivate,
  };
  public static DEPARTMENTS_DELETE: Permission = {
    PermissionKey: PermissionKeys.Departments,
    PermissionType: PermissionTypes.IsDelete,
  };

  // group defined permissions
  public static GROUP_ACCESS: Permission = {
    PermissionKey: PermissionKeys.Groups,
    PermissionType: PermissionTypes.IsRead,
  };
  public static GROUP_CREATE: Permission = {
    PermissionKey: PermissionKeys.Groups,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static GROUP_UPDATE: Permission = {
    PermissionKey: PermissionKeys.Groups,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static GROUP_ACTIVATE: Permission = {
    PermissionKey: PermissionKeys.Groups,
    PermissionType: PermissionTypes.IsActivate,
  };
  public static GROUP_DEACTIVATE: Permission = {
    PermissionKey: PermissionKeys.Groups,
    PermissionType: PermissionTypes.IsDeactivate,
  };
  // user authorized permissions
  public static USER_AUTHORIZED_ACCESS: Permission = {
    PermissionKey: PermissionKeys.UserAuthorized,
    PermissionType: PermissionTypes.IsRead,
  };
  public static USER_AUTHORIZED_CREATE: Permission = {
    PermissionKey: PermissionKeys.UserAuthorized,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static USER_AUTHORIZED_UPDATE: Permission = {
    PermissionKey: PermissionKeys.UserAuthorized,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static USER_AUTHORIZED_ACTIVATE: Permission = {
    PermissionKey: PermissionKeys.UserAuthorized,
    PermissionType: PermissionTypes.IsActivate,
  };
  public static USER_AUTHORIZED_DEACTIVATE: Permission = {
    PermissionKey: PermissionKeys.UserAuthorized,
    PermissionType: PermissionTypes.IsDeactivate,
  };

  // role defined permissions
  public static ROLE_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ManageRoles,
    PermissionType: PermissionTypes.IsRead,
  };
  public static ROLE_CREATE: Permission = {
    PermissionKey: PermissionKeys.ManageRoles,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static ROLE_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ManageRoles,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static ROLE_ACTIVATE: Permission = {
    PermissionKey: PermissionKeys.ManageRoles,
    PermissionType: PermissionTypes.IsActivate,
  };
  public static ROLE_DEACTIVATE: Permission = {
    PermissionKey: PermissionKeys.ManageRoles,
    PermissionType: PermissionTypes.IsDeactivate,
  };
  // user defined permissions
  public static USER_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ManageUsers,
    PermissionType: PermissionTypes.IsRead,
  };
  public static USER_CREATE: Permission = {
    PermissionKey: PermissionKeys.ManageUsers,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static USER_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ManageUsers,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static USER_ACTIVATE: Permission = {
    PermissionKey: PermissionKeys.ManageUsers,
    PermissionType: PermissionTypes.IsActivate,
  };
  public static USER_DEACTIVATE: Permission = {
    PermissionKey: PermissionKeys.ManageUsers,
    PermissionType: PermissionTypes.IsDeactivate,
  };
  public static USER_APPROVE: Permission = {
    PermissionKey: PermissionKeys.ManageUsers,
    PermissionType: PermissionTypes.IsApprove,
  };
  public static USER_REJECT: Permission = {
    PermissionKey: PermissionKeys.ManageUsers,
    PermissionType: PermissionTypes.IsReject,
  };
  public static USER_DELETE: Permission = {
    PermissionKey: PermissionKeys.ManageUsers,
    PermissionType: PermissionTypes.IsDelete,
  };

  // plant defined permissions
  public static PLANT_ACCESS: Permission = {
    PermissionKey: PermissionKeys.Plants,
    PermissionType: PermissionTypes.IsRead,
  };
  public static PLANT_CREATE: Permission = {
    PermissionKey: PermissionKeys.Plants,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static PLANT_UPDATE: Permission = {
    PermissionKey: PermissionKeys.Plants,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static PLANT_ACTIVATE: Permission = {
    PermissionKey: PermissionKeys.Plants,
    PermissionType: PermissionTypes.IsActivate,
  };
  public static PLANT_DEACTIVATE: Permission = {
    PermissionKey: PermissionKeys.Plants,
    PermissionType: PermissionTypes.IsDeactivate,
  };
  // EMPLOYEE defined permissions
  public static EMPLOYEE_ACCESS: Permission = {
    PermissionKey: PermissionKeys.Employees,
    PermissionType: PermissionTypes.IsRead,
  };
  public static EMPLOYEE_CREATE: Permission = {
    PermissionKey: PermissionKeys.Employees,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static EMPLOYEE_UPDATE: Permission = {
    PermissionKey: PermissionKeys.Employees,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static EMPLOYEE_ACTIVATE: Permission = {
    PermissionKey: PermissionKeys.Employees,
    PermissionType: PermissionTypes.IsActivate,
  };
  public static EMPLOYEE_DEACTIVATE: Permission = {
    PermissionKey: PermissionKeys.Employees,
    PermissionType: PermissionTypes.IsDeactivate,
  };

  // EMPLOYEE defined permissions
  public static MULTIPLE_PLANT_REQUESTS_ACCESS: Permission = {
    PermissionKey: PermissionKeys.MultiplePlantRequests,
    PermissionType: PermissionTypes.IsRead,
  };
  public static MULTIPLE_PLANT_REQUESTS_APPROVE: Permission = {
    PermissionKey: PermissionKeys.MultiplePlantRequests,
    PermissionType: PermissionTypes.IsApprove,
  };
  public static MULTIPLE_PLANT_REQUESTS_REJECT: Permission = {
    PermissionKey: PermissionKeys.MultiplePlantRequests,
    PermissionType: PermissionTypes.IsReject,
  };

  // Manage Menu permissions
  public static MENU_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ManageMenu,
    PermissionType: PermissionTypes.IsRead,
  };
  public static MENU_CREATE: Permission = {
    PermissionKey: PermissionKeys.ManageMenu,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static MENU_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ManageMenu,
    PermissionType: PermissionTypes.IsUpdate,
  };
  // public static USER_DELETE: Permission = {
  //   PermissionKey: PermissionKeys.ManageUsers,
  //   PermissionType: PermissionTypes.IsDelete,
  // };


  // Division Module
  public static DIVISION_Module_ACCESS: Permission = {
    PermissionKey: PermissionKeys.Plants,
    PermissionType: PermissionTypes.IsRead,
  };
  public static DIVISION_Module_CREATE: Permission = {
    PermissionKey: PermissionKeys.Plants,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static DIVISION_Module_UPDATE: Permission = {
    PermissionKey: PermissionKeys.Plants,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static DIVISION_Module_DELETE: Permission = {
    PermissionKey: PermissionKeys.Plants,
    PermissionType: PermissionTypes.IsDelete,
  };
  public static MACHINE_MAP_ACCESS: Permission = {
    PermissionKey: PermissionKeys.MachineMap,
    PermissionType: PermissionTypes.IsRead,
  };
  public static MACHINE_MAP_CREATE: Permission = {
    PermissionKey: PermissionKeys.MachineMap,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static MACHINE_MAP_UPDATE: Permission = {
    PermissionKey: PermissionKeys.MachineMap,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static MACHINE_MAP_DELETE: Permission = {
    PermissionKey: PermissionKeys.MachineMap,
    PermissionType: PermissionTypes.IsDelete,
  };

  //O3 Administration
  //General Category GeneralCategory
  public static GENERAL_CATEGORY_ACCESS: Permission = {
    PermissionKey: PermissionKeys.GeneralCategory,
    PermissionType: PermissionTypes.IsRead,
  };
  public static GENERAL_CATEGORY_CREATE: Permission = {
    PermissionKey: PermissionKeys.GeneralCategory,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static GENERAL_CATEGORY_UPDATE: Permission = {
    PermissionKey: PermissionKeys.GeneralCategory,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static GENERAL_CATEGORY_DELETE: Permission = {
    PermissionKey: PermissionKeys.GeneralCategory,
    PermissionType: PermissionTypes.IsDelete,
  };

  //input-output-lot screen
  public static Input_Output_Lot_ACCESS: Permission = {
    PermissionKey: PermissionKeys.InputOutputLot,
    PermissionType: PermissionTypes.IsRead,
  };
  public static Input_Output_Lot_CREATE: Permission = {
    PermissionKey: PermissionKeys.InputOutputLot,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static Input_Output_Lot_UPDATE: Permission = {
    PermissionKey: PermissionKeys.InputOutputLot,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static Input_Output_Lot_DELETE: Permission = {
    PermissionKey: PermissionKeys.InputOutputLot,
    PermissionType: PermissionTypes.IsDelete,
  };

  //iot console screen
  public static Iot_Console_ACCESS: Permission = {
    PermissionKey: PermissionKeys.IotConsole,
    PermissionType: PermissionTypes.IsRead,
  };
  public static Iot_Console_CREATE: Permission = {
    PermissionKey: PermissionKeys.IotConsole,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static Iot_Console_UPDATE: Permission = {
    PermissionKey: PermissionKeys.IotConsole,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static Iot_Console_DELETE: Permission = {
    PermissionKey: PermissionKeys.IotConsole,
    PermissionType: PermissionTypes.IsDelete,
  };


  //Coa Custumer screen
  public static Custumer_Reports_ACCESS: Permission = {
    PermissionKey: PermissionKeys.CoaCustumer,
    PermissionType: PermissionTypes.IsRead,
  };
  public static Custumer_Reports_CREATE: Permission = {
    PermissionKey: PermissionKeys.CoaCustumer,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static Custumer_Reports_UPDATE: Permission = {
    PermissionKey: PermissionKeys.CoaCustumer,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static Custumer_Reports_DELETE: Permission = {
    PermissionKey: PermissionKeys.CoaCustumer,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Cities and Countriea
  public static GENERAL_CITIES_AND_COUNTRY_ACCESS: Permission = {
    PermissionKey: PermissionKeys.CitiesAndCountries,
    PermissionType: PermissionTypes.IsRead,
  };
  public static GENERAL_CITIES_AND_COUNTRY_CREATE: Permission = {
    PermissionKey: PermissionKeys.CitiesAndCountries,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static GENERAL_CITIES_AND_COUNTRY_UPDATE: Permission = {
    PermissionKey: PermissionKeys.CitiesAndCountries,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static GENERAL_CITIES_AND_COUNTRY_DELETE: Permission = {
    PermissionKey: PermissionKeys.CitiesAndCountries,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Suppllier Detail Configuration
  public static GENERAL_SUPPLIER_DETAIL_ACCESS: Permission = {
    PermissionKey: PermissionKeys.SupplierDetailConfiguration,
    PermissionType: PermissionTypes.IsRead,
  };
  public static GENERAL_SUPPLIER_DETAIL_CREATE: Permission = {
    PermissionKey: PermissionKeys.SupplierDetailConfiguration,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static GENERAL_SUPPLIER_DETAIL_UPDATE: Permission = {
    PermissionKey: PermissionKeys.SupplierDetailConfiguration,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static GENERAL_SUPPLIER_DETAIL_DELETE: Permission = {
    PermissionKey: PermissionKeys.SupplierDetailConfiguration,
    PermissionType: PermissionTypes.IsDelete,
  };
  // MACHINE_PARAMETER
  public static MACHINE_PARAMETER_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ProcessReadingInterval,
    PermissionType: PermissionTypes.IsRead,
  };
  public static MACHINE_PARAMETER_CREATE: Permission = {
    PermissionKey: PermissionKeys.ProcessReadingInterval,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static MACHINE_PARAMETER_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ProcessReadingInterval,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static MACHINE_PARAMETER_DELETE: Permission = {
    PermissionKey: PermissionKeys.ProcessReadingInterval,
    PermissionType: PermissionTypes.IsDelete,
  };

  // PROCESS PARAMETER LOGIN
  public static PROCESS_PARAMETER_LOGIN_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ProcessReadingInterval,
    PermissionType: PermissionTypes.IsRead,
  };
  public static PROCESS_PARAMETER_LOGIN_CREATE: Permission = {
    PermissionKey: PermissionKeys.ProcessReadingInterval,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static PROCESS_PARAMETER_LOGIN_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ProcessReadingInterval,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static PROCESS_PARAMETER_LOGIN_DELETE: Permission = {
    PermissionKey: PermissionKeys.ProcessReadingInterval,
    PermissionType: PermissionTypes.IsDelete,
  };

  // PROCESS CONTROL
  public static PROCESS_CONTROL_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ProcessControl,
    PermissionType: PermissionTypes.IsRead,
  };
  public static PROCESS_CONTROL_CREATE: Permission = {
    PermissionKey: PermissionKeys.ProcessControl,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static PROCESS_CONTROL_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ProcessControl,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static PROCESS_CONTROL_DELETE: Permission = {
    PermissionKey: PermissionKeys.ProcessControl,
    PermissionType: PermissionTypes.IsDelete,
  };

  //QUALITY PARAMETER

  public static QUALITY_PARAMETER_ACCESS: Permission = {
    PermissionKey: PermissionKeys.QualityParameters,
    PermissionType: PermissionTypes.IsRead,
  };
  public static QUALITY_PARAMETER_CREATE: Permission = {
    PermissionKey: PermissionKeys.QualityParameters,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static QUALITY_PARAMETER_UPDATE: Permission = {
    PermissionKey: PermissionKeys.QualityParameters,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static QUALITY_PARAMETER_DELETE: Permission = {
    PermissionKey: PermissionKeys.QualityParameters,
    PermissionType: PermissionTypes.IsDelete,
  };

  //IMMEDIATE NCR ACTIONS
  public static IMMEDIATE_NCRACTIONS_ACCESS: Permission = {
    PermissionKey: PermissionKeys.NCRActionMaster,
    PermissionType: PermissionTypes.IsRead,
  };
  public static IMMEDIATE_NCRACTIONS_CREATE: Permission = {
    PermissionKey: PermissionKeys.NCRActionMaster,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static IMMEDIATE_NCRACTIONS_UPDATE: Permission = {
    PermissionKey: PermissionKeys.NCRActionMaster,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static IMMEDIATE_NCRACTIONS_DELETE: Permission = {
    PermissionKey: PermissionKeys.NCRActionMaster,
    PermissionType: PermissionTypes.IsDelete,
  };

  //QualitySamplingInterval  QUALITY SAMPLING INTERVAL
  // DT Configuration
  public static MA_DT_CONFIGURATION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.DTConfiguration,
    PermissionType: PermissionTypes.IsRead,
  };
  public static MA_DT_CONFIGURATION_CREATE: Permission = {
    PermissionKey: PermissionKeys.DTConfiguration,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static MA_DT_CONFIGURATION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.DTConfiguration,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static MA_DT_CONFIGURATION_DELETE: Permission = {
    PermissionKey: PermissionKeys.DTConfiguration,
    PermissionType: PermissionTypes.IsDelete,
  };
  // QCBox
  public static Quality_QCBox_ACCESS: Permission = {
    PermissionKey: PermissionKeys.QCBox,
    PermissionType: PermissionTypes.IsRead,
  };
  public static Quality_QCBox_CREATE: Permission = {
    PermissionKey: PermissionKeys.QCBox,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static Quality_QCBox_UPDATE: Permission = {
    PermissionKey: PermissionKeys.QCBox,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static Quality_QCBox_DELETE: Permission = {
    PermissionKey: PermissionKeys.QCBox,
    PermissionType: PermissionTypes.IsDelete,
  };

  public static QUALITY_SAMPLING_INTERVAL_ACCESS: Permission = {
    PermissionKey: PermissionKeys.QualitySamplingInterval,
    PermissionType: PermissionTypes.IsRead,
  };
  public static QUALITY_SAMPLING_INTERVAL_CREATE: Permission = {
    PermissionKey: PermissionKeys.QualitySamplingInterval,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static QUALITY_SAMPLING_INTERVAL_UPDATE: Permission = {
    PermissionKey: PermissionKeys.QualitySamplingInterval,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static QUALITY_SAMPLING_INTERVAL_DELETE: Permission = {
    PermissionKey: PermissionKeys.QualitySamplingInterval,
    PermissionType: PermissionTypes.IsDelete,
  };

  // QUALITY CONTROL
  public static QUALITY_CONTROL_ACCESS: Permission = {
    PermissionKey: PermissionKeys.QualityControl,
    PermissionType: PermissionTypes.IsRead,
  };
  public static QUALITY_CONTROL_CREATE: Permission = {
    PermissionKey: PermissionKeys.QualityControl,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static QUALITY_CONTROL_UPDATE: Permission = {
    PermissionKey: PermissionKeys.QualityControl,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static QUALITY_CONTROL_DELETE: Permission = {
    PermissionKey: PermissionKeys.QualityControl,
    PermissionType: PermissionTypes.IsDelete,
  };

  //CREW SCHEDULE

  public static CREW_SCHEDULE_ACCESS: Permission = {
    PermissionKey: PermissionKeys.CrewSchedule,
    PermissionType: PermissionTypes.IsRead,
  };
  public static CREW_SCHEDULE_CREATE: Permission = {
    PermissionKey: PermissionKeys.CrewSchedule,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static CREW_SCHEDULE_UPDATE: Permission = {
    PermissionKey: PermissionKeys.CrewSchedule,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static CREW_SCHEDULE_DELETE: Permission = {
    PermissionKey: PermissionKeys.CrewSchedule,
    PermissionType: PermissionTypes.IsDelete,
  };
  //OEE_CONFIGURATION

  public static OEE_CONFIGURATION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.OEEConfiguration,
    PermissionType: PermissionTypes.IsRead,
  };
  public static OEE_CONFIGURATION_CREATE: Permission = {
    PermissionKey: PermissionKeys.OEEConfiguration,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static OEE_CONFIGURATION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.OEEConfiguration,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static OEE_CONFIGURATION_DELETE: Permission = {
    PermissionKey: PermissionKeys.OEEConfiguration,
    PermissionType: PermissionTypes.IsDelete,
  };
  //SFDC CONFIGURATION

  public static SFDC_CONFIGURATION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.SFDCConfiguration,
    PermissionType: PermissionTypes.IsRead,
  };
  public static SFDC_CONFIGURATION_CREATE: Permission = {
    PermissionKey: PermissionKeys.SFDCConfiguration,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static SFDC_CONFIGURATION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.SFDCConfiguration,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static SFDC_CONFIGURATION_DELETE: Permission = {
    PermissionKey: PermissionKeys.SFDCConfiguration,
    PermissionType: PermissionTypes.IsDelete,
  };

  // PRODUCTION ORDER

  public static PRODUCTION_ORDER_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ProductionOrder,
    PermissionType: PermissionTypes.IsRead,
  };
  public static PRODUCTION_ORDER_CREATE: Permission = {
    PermissionKey: PermissionKeys.ProductionOrder,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static PRODUCTION_ORDER_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ProductionOrder,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static PRODUCTION_ORDER_DELETE: Permission = {
    PermissionKey: PermissionKeys.ProductionOrder,
    PermissionType: PermissionTypes.IsDelete,
  };

  // PRODUCTION ORDER Permission

  public static PRODUCTION_ORDER_PERMISSION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ProductionOrderPermission,
    PermissionType: PermissionTypes.IsRead,
  };
  public static PRODUCTION_ORDER_PERMISSION_CREATE: Permission = {
    PermissionKey: PermissionKeys.ProductionOrderPermission,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static PRODUCTION_ORDER_PERMISSION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ProductionOrderPermission,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static PRODUCTION_ORDER_PERMISSION_DELETE: Permission = {
    PermissionKey: PermissionKeys.ProductionOrderPermission,
    PermissionType: PermissionTypes.IsDelete,
  };

  // PRODUCTION START UPDATE

  public static PRODUCTION_START_UPDATE_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ProductionStartUpdate,
    PermissionType: PermissionTypes.IsRead,
  };
  public static PRODUCTION_START_UPDATE_CREATE: Permission = {
    PermissionKey: PermissionKeys.ProductionStartUpdate,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static PRODUCTION_START_UPDATE_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ProductionStartUpdate,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static PRODUCTION_START_UPDATE_DELETE: Permission = {
    PermissionKey: PermissionKeys.ProductionStartUpdate,
    PermissionType: PermissionTypes.IsDelete,
  };
  // ERP MACHINE MAPPING

  public static ERP_MACHINE_MAPPING_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ERPMachineMapping,
    PermissionType: PermissionTypes.IsRead,
  };
  public static ERP_MACHINE_MAPPING_CREATE: Permission = {
    PermissionKey: PermissionKeys.ERPMachineMapping,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static ERP_MACHINE_MAPPING_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ERPMachineMapping,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static ERP_MACHINE_MAPPING_DELETE: Permission = {
    PermissionKey: PermissionKeys.ERPMachineMapping,
    PermissionType: PermissionTypes.IsDelete,
  };
  // ERP PLANT MAPPING

  public static ERP_PLANT_MAPPING_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ERPPlantMapping,
    PermissionType: PermissionTypes.IsRead,
  };
  public static ERP_PLANT_MAPPING_CREATE: Permission = {
    PermissionKey: PermissionKeys.ERPPlantMapping,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static ERP_PLANT_MAPPING_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ERPPlantMapping,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static ERP_PLANT_MAPPING_DELETE: Permission = {
    PermissionKey: PermissionKeys.ERPPlantMapping,
    PermissionType: PermissionTypes.IsDelete,
  };
  //ERP PRODUCTION ORDER
  public static ERP_PRODUCTION_ORDER_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ERPProductionOrder,
    PermissionType: PermissionTypes.IsRead,
  };
  public static ERP_PRODUCTION_ORDER_CREATE: Permission = {
    PermissionKey: PermissionKeys.ERPProductionOrder,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static ERP_PRODUCTION_ORDER_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ERPProductionOrder,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static ERP_PRODUCTION_ORDER_DELETE: Permission = {
    PermissionKey: PermissionKeys.ERPProductionOrder,
    PermissionType: PermissionTypes.IsDelete,
  };
  // WASTE SUPERVISORY SCREEN

  public static WASTE_SUPERVISORY_SCREEN_ACCESS: Permission = {
    PermissionKey: PermissionKeys.WasteSupervisoryScreen,
    PermissionType: PermissionTypes.IsRead,
  };
  public static WASTE_SUPERVISORY_SCREEN_CREATE: Permission = {
    PermissionKey: PermissionKeys.WasteSupervisoryScreen,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static WASTE_SUPERVISORY_SCREEN_UPDATE: Permission = {
    PermissionKey: PermissionKeys.WasteSupervisoryScreen,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static WASTE_SUPERVISORY_SCREEN_DELETE: Permission = {
    PermissionKey: PermissionKeys.WasteSupervisoryScreen,
    PermissionType: PermissionTypes.IsDelete,
  };

  // WASTE SUPERVISORY SCREEN

  public static MA_PRODUCT_DETAIL_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ProductConfiguration,
    PermissionType: PermissionTypes.IsRead,
  };
  public static MA_PRODUCT_DETAIL_CREATE: Permission = {
    PermissionKey: PermissionKeys.ProductConfiguration,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static MA_PRODUCT_DETAIL_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ProductConfiguration,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static MA_PRODUCT_DETAIL_DELETE: Permission = {
    PermissionKey: PermissionKeys.ProductConfiguration,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Material Mater SCREEN

  public static Master_Material_ACCESS: Permission = {
    PermissionKey: PermissionKeys.MaterialMaster,
    PermissionType: PermissionTypes.IsRead,
  };
  public static Master_Material_CREATE: Permission = {
    PermissionKey: PermissionKeys.MaterialMaster,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static Master_Material_UPDATE: Permission = {
    PermissionKey: PermissionKeys.MaterialMaster,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static Master_Material_DELETE: Permission = {
    PermissionKey: PermissionKeys.MaterialMaster,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Material Defination SCREEN

  public static Material_Defination_ACCESS: Permission = {
    PermissionKey: PermissionKeys.MaterialDefination,
    PermissionType: PermissionTypes.IsRead,
  };
  public static Material_Defination_CREATE: Permission = {
    PermissionKey: PermissionKeys.MaterialDefination,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static Material_Defination_UPDATE: Permission = {
    PermissionKey: PermissionKeys.MaterialDefination,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static Material_Defination_DELETE: Permission = {
    PermissionKey: PermissionKeys.MaterialDefination,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Material Repoet Screen

  public static Material_Report_ACCESS: Permission = {
    PermissionKey: PermissionKeys.MaterialAnalysisComparison,
    PermissionType: PermissionTypes.IsRead,
  };
  public static Material_Report_CREATE: Permission = {
    PermissionKey: PermissionKeys.MaterialAnalysisComparison,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static Material_Report_UPDATE: Permission = {
    PermissionKey: PermissionKeys.MaterialAnalysisComparison,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static Material_Report_DELETE: Permission = {
    PermissionKey: PermissionKeys.MaterialAnalysisComparison,
    PermissionType: PermissionTypes.IsDelete,
  };

  //Pest Control Screens
  public static Material_Execution_ACCESS: Permission = {
    PermissionKey: PermissionKeys.MaterialExecution,
    PermissionType: PermissionTypes.IsRead,
  };
  public static Material_Execution_CREATE: Permission = {
    PermissionKey: PermissionKeys.MaterialExecution,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static Material_Execution_UPDATE: Permission = {
    PermissionKey: PermissionKeys.MaterialExecution,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static Material_Execution_DELETE: Permission = {
    PermissionKey: PermissionKeys.MaterialExecution,
    PermissionType: PermissionTypes.IsDelete,
  };



  //Pest Control Screens
  public static DETECTOR_ACCESS: Permission = {
    PermissionKey: PermissionKeys.Detector,
    PermissionType: PermissionTypes.IsRead,
  };
  public static DETECTOR_CREATE: Permission = {
    PermissionKey: PermissionKeys.Detector,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static DETECTOR_UPDATE: Permission = {
    PermissionKey: PermissionKeys.Detector,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static DETECTOR_DELETE: Permission = {
    PermissionKey: PermissionKeys.Detector,
    PermissionType: PermissionTypes.IsDelete,
  };

  //Priority
  public static PRIORITY_ACCESS: Permission = {
    PermissionKey: PermissionKeys.PestPriority,
    PermissionType: PermissionTypes.IsRead,
  };
  public static PRIORITY_CREATE: Permission = {
    PermissionKey: PermissionKeys.PestPriority,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static PRIORITY_UPDATE: Permission = {
    PermissionKey: PermissionKeys.PestPriority,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static PRIORITY_DELETE: Permission = {
    PermissionKey: PermissionKeys.PestPriority,
    PermissionType: PermissionTypes.IsDelete,
  };
  //Recommendation
  public static RECOMMENDATION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.Recommendation,
    PermissionType: PermissionTypes.IsRead,
  };
  public static RECOMMENDATION_CREATE: Permission = {
    PermissionKey: PermissionKeys.Recommendation,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static RECOMMENDATION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.Recommendation,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static RECOMMENDATION_DELETE: Permission = {
    PermissionKey: PermissionKeys.Recommendation,
    PermissionType: PermissionTypes.IsDelete,
  };
  //STATION Configuration
  public static STATION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.StationConfiguration,
    PermissionType: PermissionTypes.IsRead,
  };
  public static STATION_CREATE: Permission = {
    PermissionKey: PermissionKeys.StationConfiguration,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static STATION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.StationConfiguration,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static STATION_DELETE: Permission = {
    PermissionKey: PermissionKeys.StationConfiguration,
    PermissionType: PermissionTypes.IsDelete,
  };

  //Zone/FLoor
  public static Zone_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ZoneFloor,
    PermissionType: PermissionTypes.IsRead,
  };
  public static Zone_CREATE: Permission = {
    PermissionKey: PermissionKeys.ZoneFloor,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static Zone_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ZoneFloor,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static Zone_DELETE: Permission = {
    PermissionKey: PermissionKeys.ZoneFloor,
    PermissionType: PermissionTypes.IsDelete,
  };

  //Pest Type & Species
  public static PESTTYPESPECIES_ACCESS: Permission = {
    PermissionKey: PermissionKeys.PestTypeSpecies,
    PermissionType: PermissionTypes.IsRead,
  };
  public static PESTTYPESPECIES_CREATE: Permission = {
    PermissionKey: PermissionKeys.PestTypeSpecies,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static PESTTYPESPECIES_UPDATE: Permission = {
    PermissionKey: PermissionKeys.PestTypeSpecies,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static PESTTYPESPECIES_DELETE: Permission = {
    PermissionKey: PermissionKeys.PestTypeSpecies,
    PermissionType: PermissionTypes.IsDelete,
  };

  //Detector Symbol
  public static DETECTORSYMBOL_ACCESS: Permission = {
    PermissionKey: PermissionKeys.DetectorSymbol,
    PermissionType: PermissionTypes.IsRead,
  };
  public static DETECTORSYMBOL_CREATE: Permission = {
    PermissionKey: PermissionKeys.DetectorSymbol,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static DETECTORSYMBOL_UPDATE: Permission = {
    PermissionKey: PermissionKeys.DetectorSymbol,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static DETECTORSYMBOL_DELETE: Permission = {
    PermissionKey: PermissionKeys.DetectorSymbol,
    PermissionType: PermissionTypes.IsDelete,
  };

  //Infestation & Activity level
  public static INFESTATIONLEVEL_ACCESS: Permission = {
    PermissionKey: PermissionKeys.InfestationLevel,
    PermissionType: PermissionTypes.IsRead,
  };
  public static INFESTATIONLEVEL_CREATE: Permission = {
    PermissionKey: PermissionKeys.InfestationLevel,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static INFESTATIONLEVEL_UPDATE: Permission = {
    PermissionKey: PermissionKeys.InfestationLevel,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static INFESTATIONLEVEL_DELETE: Permission = {
    PermissionKey: PermissionKeys.InfestationLevel,
    PermissionType: PermissionTypes.IsDelete,
  };

  //Visit Request
  public static VISITREQUEST_ACCESS: Permission = {
    PermissionKey: PermissionKeys.VisitRequest,
    PermissionType: PermissionTypes.IsRead,
  };
  public static VISITREQUEST_CREATE: Permission = {
    PermissionKey: PermissionKeys.VisitRequest,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static VISITREQUEST_UPDATE: Permission = {
    PermissionKey: PermissionKeys.VisitRequest,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static VISITREQUEST_DELETE: Permission = {
    PermissionKey: PermissionKeys.VisitRequest,
    PermissionType: PermissionTypes.IsDelete,
  };

  //Predefined Reasons
  public static PREDEFINEDREASONS_ACCESS: Permission = {
    PermissionKey: PermissionKeys.PredefinedReasons,
    PermissionType: PermissionTypes.IsRead,
  };
  public static PREDEFINEDREASONS_CREATE: Permission = {
    PermissionKey: PermissionKeys.PredefinedReasons,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static PREDEFINEDREASONS_UPDATE: Permission = {
    PermissionKey: PermissionKeys.PredefinedReasons,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static PREDEFINEDREASONS_DELETE: Permission = {
    PermissionKey: PermissionKeys.PredefinedReasons,
    PermissionType: PermissionTypes.IsDelete,
  };

  //Immediate Action
  //Master Data
  public static ImmediateAction_ACCESS: Permission = {
    PermissionKey: PermissionKeys.NcrActionMaster,
    PermissionType: PermissionTypes.IsRead,
  };
  public static ImmediateAction_CREATE: Permission = {
    PermissionKey: PermissionKeys.NcrActionMaster,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static ImmediateAction_UPDATE: Permission = {
    PermissionKey: PermissionKeys.NcrActionMaster,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static ImmediateAction_DELETE: Permission = {
    PermissionKey: PermissionKeys.NcrActionMaster,
    PermissionType: PermissionTypes.IsDelete,
  };

  //Sorting Report

  public static SortingReport_ACCESS: Permission = {
    PermissionKey: PermissionKeys.SortingReport,
    PermissionType: PermissionTypes.IsRead,
  };
  public static SortingReport_CREATE: Permission = {
    PermissionKey: PermissionKeys.SortingReport,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static SortingReport_UPDATE: Permission = {
    PermissionKey: PermissionKeys.SortingReport,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static SortingReport_DELETE: Permission = {
    PermissionKey: PermissionKeys.SortingReport,
    PermissionType: PermissionTypes.IsDelete,
  };

  //Immediate Action Screen

  public static ImmediateActionScreen_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ImmediateAction,
    PermissionType: PermissionTypes.IsRead,
  };
  public static ImmediateActionScreen_CREATE: Permission = {
    PermissionKey: PermissionKeys.ImmediateAction,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static ImmediateActionScreen_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ImmediateAction,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static ImmediateActionScreen_DELETE: Permission = {
    PermissionKey: PermissionKeys.ImmediateAction,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Approve Immediate Action Screen

  public static ApproveImmediateActionScreen_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ApproveImmediateActions,
    PermissionType: PermissionTypes.IsRead,
  };
  public static ApproveImmediateActionScreen_CREATE: Permission = {
    PermissionKey: PermissionKeys.ApproveImmediateActions,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static ApproveImmediateActionScreen_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ApproveImmediateActions,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static ApproveImmediateActionScreen_DELETE: Permission = {
    PermissionKey: PermissionKeys.ApproveImmediateActions,
    PermissionType: PermissionTypes.IsDelete,
  };

  // SHOP FLOOR DATA
  //PESTICIDES
  public static PESTICIDES_ACCESS: Permission = {
    PermissionKey: PermissionKeys.PredefinedReasons,
    PermissionType: PermissionTypes.IsRead,
  };
  public static PESTICIDES_CREATE: Permission = {
    PermissionKey: PermissionKeys.PredefinedReasons,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static PESTICIDES_UPDATE: Permission = {
    PermissionKey: PermissionKeys.PredefinedReasons,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static PESTICIDES_DELETE: Permission = {
    PermissionKey: PermissionKeys.PredefinedReasons,
    PermissionType: PermissionTypes.IsDelete,
  };

  //Maps
  public static MAPS_ACCESS: Permission = {
    PermissionKey: PermissionKeys.Maps,
    PermissionType: PermissionTypes.IsRead,
  };
  public static MAPS_CREATE: Permission = {
    PermissionKey: PermissionKeys.Maps,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static MAPS_UPDATE: Permission = {
    PermissionKey: PermissionKeys.Maps,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static MAPS_DELETE: Permission = {
    PermissionKey: PermissionKeys.Maps,
    PermissionType: PermissionTypes.IsDelete,
  };

  // SHOP FLOOR DATA

  public static SHOP_FLOOR_DATA_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ShopFloorData,
    PermissionType: PermissionTypes.IsRead,
  };
  public static SHOP_FLOOR_DATA_CREATE: Permission = {
    PermissionKey: PermissionKeys.ShopFloorData,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static SHOP_FLOOR_DATA_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ShopFloorData,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static SHOP_FLOOR_DATA_DELETE: Permission = {
    PermissionKey: PermissionKeys.ShopFloorData,
    PermissionType: PermissionTypes.IsDelete,
  };

  // ITEM BOM CONFIGURATION

  public static ITEM_BOM_CONFIGURATION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ItemBOMConfiguration,
    PermissionType: PermissionTypes.IsRead,
  };
  public static ITEM_BOM_CONFIGURATION_CREATE: Permission = {
    PermissionKey: PermissionKeys.ItemBOMConfiguration,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static ITEM_BOM_CONFIGURATION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ItemBOMConfiguration,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static ITEM_BOM_CONFIGURATION_DELETE: Permission = {
    PermissionKey: PermissionKeys.ItemBOMConfiguration,
    PermissionType: PermissionTypes.IsDelete,
  };
  //-----------QX Matrics-----------//
  public static QX_MATRIX_ACCESS: Permission = {
    PermissionKey: PermissionKeys.QXMatrix,
    PermissionType: PermissionTypes.IsRead,
  };
  public static QX_MATRIX_CREATE: Permission = {
    PermissionKey: PermissionKeys.QXMatrix,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static QX_MATRIX_UPDATE: Permission = {
    PermissionKey: PermissionKeys.QXMatrix,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static QX_MATRIX_DELETE: Permission = {
    PermissionKey: PermissionKeys.QXMatrix,
    PermissionType: PermissionTypes.IsDelete,
  };

  //SHOP FLOOR DATA FOOD

  public static SHOP_FLOOR_DATA_FOOD_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ShopFloorDataFood,
    PermissionType: PermissionTypes.IsRead,
  };
  public static SHOP_FLOOR_DATA_FOOD_CREATE: Permission = {
    PermissionKey: PermissionKeys.ShopFloorDataFood,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static SHOP_FLOOR_DATA_FOOD_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ShopFloorDataFood,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static SHOP_FLOOR_DATA_FOOD_DELETE: Permission = {
    PermissionKey: PermissionKeys.ShopFloorDataFood,
    PermissionType: PermissionTypes.IsDelete,
  };
  // WASTE CF MAPPING

  public static WASTE_CF_MAPPING_ACCESS: Permission = {
    PermissionKey: PermissionKeys.WasteCFMapping,
    PermissionType: PermissionTypes.IsRead,
  };
  public static WASTE_CF_MAPPING_CREATE: Permission = {
    PermissionKey: PermissionKeys.WasteCFMapping,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static WASTE_CF_MAPPING_UPDATE: Permission = {
    PermissionKey: PermissionKeys.WasteCFMapping,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static WASTE_CF_MAPPING_DELETE: Permission = {
    PermissionKey: PermissionKeys.WasteCFMapping,
    PermissionType: PermissionTypes.IsDelete,
  };

  // LANGUAGE MASTER LanguageMaster

  public static LANGUAGE_MASTER_ACCESS: Permission = {
    PermissionKey: PermissionKeys.LanguageMaster,
    PermissionType: PermissionTypes.IsRead,
  };
  public static LANGUAGE_MASTER_CREATE: Permission = {
    PermissionKey: PermissionKeys.LanguageMaster,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static LANGUAGE_MASTER_UPDATE: Permission = {
    PermissionKey: PermissionKeys.LanguageMaster,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static LANGUAGE_MASTER_DELETE: Permission = {
    PermissionKey: PermissionKeys.LanguageMaster,
    PermissionType: PermissionTypes.IsDelete,
  };
  //UNIT OF MEASURE
  public static UNIT_OF_MEASURE_ACCESS: Permission = {
    PermissionKey: PermissionKeys.UnitOfMeasure,
    PermissionType: PermissionTypes.IsRead,
  };
  public static UNIT_OF_MEASURE_CREATE: Permission = {
    PermissionKey: PermissionKeys.UnitOfMeasure,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static UNIT_OF_MEASURE_UPDATE: Permission = {
    PermissionKey: PermissionKeys.UnitOfMeasure,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static UNIT_OF_MEASURE_DELETE: Permission = {
    PermissionKey: PermissionKeys.UnitOfMeasure,
    PermissionType: PermissionTypes.IsDelete,
  };
  // COST MASTER BREAKDOWN CONFIGURATION

  public static QM_QMD_COST_MASTER_BREAKDOWN_ACCESS: Permission = {
    PermissionKey: PermissionKeys.CostMasterBreakdown,
    PermissionType: PermissionTypes.IsRead,
  };
  public static QM_QMD_COST_MASTER_BREAKDOWN_CREATE: Permission = {
    PermissionKey: PermissionKeys.CostMasterBreakdown,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static QM_QMD_COST_MASTER_BREAKDOWN_UPDATE: Permission = {
    PermissionKey: PermissionKeys.CostMasterBreakdown,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static QM_QMD_COST_MASTER_BREAKDOWN_DELETE: Permission = {
    PermissionKey: PermissionKeys.CostMasterBreakdown,
    PermissionType: PermissionTypes.IsDelete,
  };

  // CHECKLIST CONFIGURATION CONFIGURATION

  public static CHECKLIST_CONFIGURATION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ChecklistConfiguration,
    PermissionType: PermissionTypes.IsRead,
  };
  public static CHECKLIST_CONFIGURATION_CREATE: Permission = {
    PermissionKey: PermissionKeys.ChecklistConfiguration,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static CHECKLIST_CONFIGURATION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ChecklistConfiguration,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static CHECKLIST_CONFIGURATION_DELETE: Permission = {
    PermissionKey: PermissionKeys.ChecklistConfiguration,
    PermissionType: PermissionTypes.IsDelete,
  };

  // CHECKLIST EXECUTION CONFIGURATION
  public static CHECKLIST_EXECUTION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ChecklistExecution,
    PermissionType: PermissionTypes.IsRead,
  };
  public static CHECKLIST_EXECUTION_CREATE: Permission = {
    PermissionKey: PermissionKeys.ChecklistExecution,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static CHECKLIST_EXECUTION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ChecklistExecution,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static CHECKLIST_EXECUTION_DELETE: Permission = {
    PermissionKey: PermissionKeys.ChecklistExecution,
    PermissionType: PermissionTypes.IsDelete,
  };

  // CHECKLIST HISTORY CONFIGURATION
  public static CHECKLIST_HISTORY_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ChecklistHistory,
    PermissionType: PermissionTypes.IsRead,
  };
  public static CHECKLIST_HISTORY_CREATE: Permission = {
    PermissionKey: PermissionKeys.ChecklistHistory,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static CHECKLIST_HISTORY_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ChecklistHistory,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static CHECKLIST_HISTORY_DELETE: Permission = {
    PermissionKey: PermissionKeys.ChecklistHistory,
    PermissionType: PermissionTypes.IsDelete,
  };


  // QCParameterApprovalReport Component 

  public static QC_PARAMETER_APPROVAL_REPORT_ACCESS: Permission = {
    PermissionKey: PermissionKeys.QCParameterApprovalReport,
    PermissionType: PermissionTypes.IsRead,
  };
  public static QC_PARAMETER_APPROVAL_REPORT_CREATE: Permission = {
    PermissionKey: PermissionKeys.QCParameterApprovalReport,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static QC_PARAMETER_APPROVAL_REPORT_UPDATE: Permission = {
    PermissionKey: PermissionKeys.QCParameterApprovalReport,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static QC_PARAMETER_APPROVAL_REPORT_DELETE: Permission = {
    PermissionKey: PermissionKeys.QCParameterApprovalReport,
    PermissionType: PermissionTypes.IsDelete,
  };

  // NCR Management
  public static QM_NCR_MANAGEMENT_ACCESS: Permission = {
    PermissionKey: PermissionKeys.NCRManagement,
    PermissionType: PermissionTypes.IsRead,
  };
  public static QM_NCR_MANAGEMENT_CREATE: Permission = {
    PermissionKey: PermissionKeys.NCRManagement,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static QM_NCR_MANAGEMENT_UPDATE: Permission = {
    PermissionKey: PermissionKeys.NCRManagement,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static QM_NCR_MANAGEMENT_DELETE: Permission = {
    PermissionKey: PermissionKeys.NCRManagement,
    PermissionType: PermissionTypes.IsDelete,
  };

  // CCR Management
  public static QM_CustomerComplaintManagement_ACCESS: Permission = {
    PermissionKey: PermissionKeys.CustomerComplaintManagement,
    PermissionType: PermissionTypes.IsRead,
  };
  public static QM_CustomerComplaintManagement_CREATE: Permission = {
    PermissionKey: PermissionKeys.CustomerComplaintManagement,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static QM_CustomerComplaintManagement_UPDATE: Permission = {
    PermissionKey: PermissionKeys.CustomerComplaintManagement,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static QM_CustomerComplaintManagement_DELETE: Permission = {
    PermissionKey: PermissionKeys.CustomerComplaintManagement,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Customer Management
  public static QM_CUSTOMER_MANAGEMENT_ACCESS: Permission = {
    PermissionKey: PermissionKeys.CustomerManagement,
    PermissionType: PermissionTypes.IsRead,
  };
  public static QM_CUSTOMER_MANAGEMENT_CREATE: Permission = {
    PermissionKey: PermissionKeys.CustomerManagement,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static QM_CUSTOMER_MANAGEMENT_UPDATE: Permission = {
    PermissionKey: PermissionKeys.CustomerManagement,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static QM_CUSTOMER_MANAGEMENT_DELETE: Permission = {
    PermissionKey: PermissionKeys.CustomerManagement,
    PermissionType: PermissionTypes.IsDelete,
  };
  //BATCH CONFIGURATION
  public static BATCH_CONFIGURATION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.BatchConfiguration,
    PermissionType: PermissionTypes.IsRead,
  };
  public static BATCH_CONFIGURATION_CREATE: Permission = {
    PermissionKey: PermissionKeys.BatchConfiguration,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static BATCH_CONFIGURATION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.BatchConfiguration,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static BATCH_CONFIGURATION_DELETE: Permission = {
    PermissionKey: PermissionKeys.BatchConfiguration,
    PermissionType: PermissionTypes.IsDelete,
  };

  //CUSTOMERS MANAGEMENT

  public static CUSTOMER_MANAGEMENT_ACCESS: Permission = {
    PermissionKey: PermissionKeys.CustomerManagement,
    PermissionType: PermissionTypes.IsRead,
  };
  public static CUSTOMER_MANAGEMENT_CREATE: Permission = {
    PermissionKey: PermissionKeys.CustomerManagement,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static CUSTOMER_MANAGEMENT_UPDATE: Permission = {
    PermissionKey: PermissionKeys.CustomerManagement,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static CUSTOMER_MANAGEMENT_DELETE: Permission = {
    PermissionKey: PermissionKeys.CustomerManagement,
    PermissionType: PermissionTypes.IsDelete,
  };

  // GENERAL CATEGORY
  public static O3A_GS_GENERAL_CATEGORY_ACCESS: Permission = {
    PermissionKey: PermissionKeys.GeneralCategory,
    PermissionType: PermissionTypes.IsRead,
  };
  public static O3A_GS_GENERAL_CATEGORY_CREATE: Permission = {
    PermissionKey: PermissionKeys.GeneralCategory,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static O3A_GS_GENERAL_CATEGORY_UPDATE: Permission = {
    PermissionKey: PermissionKeys.GeneralCategory,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static O3A_GS_GENERAL_CATEGORY_DELETE: Permission = {
    PermissionKey: PermissionKeys.GeneralCategory,
    PermissionType: PermissionTypes.IsDelete,
  };
  //CUSTOMERS USER MANAGEMENT
  public static CUSTOMER_USER_MANAGEMENT_ACCESS: Permission = {
    PermissionKey: PermissionKeys.CustomerUsers,
    PermissionType: PermissionTypes.IsRead,
  };
  public static CUSTOMER_USER_MANAGEMENT_CREATE: Permission = {
    PermissionKey: PermissionKeys.CustomerUsers,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static CUSTOMER_USER_MANAGEMENT_UPDATE: Permission = {
    PermissionKey: PermissionKeys.CustomerUsers,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static CUSTOMER_USER_MANAGEMENT_DELETE: Permission = {
    PermissionKey: PermissionKeys.CustomerUsers,
    PermissionType: PermissionTypes.IsDelete,
  };
  //QX Matrix Report
  public static QX_MATRIX_REPORT_ACCESS: Permission = {
    PermissionKey: PermissionKeys.QXMatrixReport,
    PermissionType: PermissionTypes.IsRead,
  };
  public static QX_MATRIX_REPORT_CREATE: Permission = {
    PermissionKey: PermissionKeys.QXMatrixReport,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static QX_MATRIX_REPORT_UPDATE: Permission = {
    PermissionKey: PermissionKeys.QXMatrixReport,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static QX_MATRIX_REPORT_DELETE: Permission = {
    PermissionKey: PermissionKeys.QXMatrixReport,
    PermissionType: PermissionTypes.IsDelete,
  };

  // ---------Analytical Tools Module--------
  //RCA & SWOT Analysis
  public static ANALYTICAL_TOOLS_ACCESS: Permission = {
    PermissionKey: PermissionKeys.RCASWOTAnalysis,
    PermissionType: PermissionTypes.IsRead,
  };
  public static ANALYTICAL_TOOLS_CREATE: Permission = {
    PermissionKey: PermissionKeys.RCASWOTAnalysis,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static ANALYTICAL_TOOLS_UPDATE: Permission = {
    PermissionKey: PermissionKeys.RCASWOTAnalysis,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static ANALYTICAL_TOOLS_DELETE: Permission = {
    PermissionKey: PermissionKeys.RCASWOTAnalysis,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Material Availability Check
  public static MATERAL_AVAILABILITY_CHECK_ACCESS: Permission = {
    PermissionKey: PermissionKeys.MaterialAVailabilityCheck,
    PermissionType: PermissionTypes.IsRead,
  };
  public static MATERAL_AVAILABILITY_CHECK_CREATE: Permission = {
    PermissionKey: PermissionKeys.MaterialAVailabilityCheck,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static MATERAL_AVAILABILITY_CHECK_UPDATE: Permission = {
    PermissionKey: PermissionKeys.MaterialAVailabilityCheck,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static MATERAL_AVAILABILITY_CHECK_DELETE: Permission = {
    PermissionKey: PermissionKeys.MaterialAVailabilityCheck,
    PermissionType: PermissionTypes.IsDelete,
  };

  //CUSTOMER PROFILE UPLOAD

  public static CUSTOMER_PROFILE_UPLOAD_ACCESS: Permission = {
    PermissionKey: PermissionKeys.CompanyProfile,
    PermissionType: PermissionTypes.IsRead,
  };
  public static CUSTOMER_PROFILE_UPLOAD_CREATE: Permission = {
    PermissionKey: PermissionKeys.CompanyProfile,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static CUSTOMER_PROFILE_UPLOAD_UPDATE: Permission = {
    PermissionKey: PermissionKeys.CompanyProfile,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static CUSTOMER_PROFILE_UPLOAD_DELETE: Permission = {
    PermissionKey: PermissionKeys.CompanyProfile,
    PermissionType: PermissionTypes.IsDelete,
  };


  // Batch Configuartion Unit Linking

  public static BatchConfiguration_UnitLinking_ACCESS: Permission = {
    PermissionKey: PermissionKeys.BatchConfiguration_UnitLinking,
    PermissionType: PermissionTypes.IsRead,
  };
  public static BatchConfiguration_UnitLinking_CREATE: Permission = {
    PermissionKey: PermissionKeys.BatchConfiguration_UnitLinking,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static BatchConfiguration_UnitLinking_UPDATE: Permission = {
    PermissionKey: PermissionKeys.BatchConfiguration_UnitLinking,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static BatchConfiguration_UnitLinking_DELETE: Permission = {
    PermissionKey: PermissionKeys.BatchConfiguration_UnitLinking,
    PermissionType: PermissionTypes.IsDelete,
  };

  // PALLET BARCODE TRACKING

  public static PALLET_BARCODE_TRACKING_ACCESS: Permission = {
    PermissionKey: PermissionKeys.PalletBarcodeTracking,
    PermissionType: PermissionTypes.IsRead,
  };

  public static PALLET_BARCODE_TRACKING_CREATE: Permission = {
    PermissionKey: PermissionKeys.PalletBarcodeTracking,
    PermissionType: PermissionTypes.IsWrite,
  };

  public static PALLET_BARCODE_TRACKING_UPDATE: Permission = {
    PermissionKey: PermissionKeys.PalletBarcodeTracking,
    PermissionType: PermissionTypes.IsUpdate,
  };

  public static PALLET_BARCODE_TRACKING_DELETE: Permission = {
    PermissionKey: PermissionKeys.PalletBarcodeTracking,
    PermissionType: PermissionTypes.IsDelete,
  };

  //MAster DAta Screen Pest Control
  public static MASTER_DATA_ACCESS: Permission = {
    PermissionKey: PermissionKeys.MasterData,
    PermissionType: PermissionTypes.IsRead,
  };
  public static MASTER_DATA_CREATE: Permission = {
    PermissionKey: PermissionKeys.MasterData,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static MASTER_DATA_UPDATE: Permission = {
    PermissionKey: PermissionKeys.MasterData,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static MASTER_DATA_DELETE: Permission = {
    PermissionKey: PermissionKeys.MasterData,
    PermissionType: PermissionTypes.IsDelete,
  };


  //Asset Detail Component 
  public static Asset_Detail_ACCESS: Permission = {
    PermissionKey: PermissionKeys.AssetCalibration,
    PermissionType: PermissionTypes.IsRead,
  };
  public static Asset_Detail_CREATE: Permission = {
    PermissionKey: PermissionKeys.AssetCalibration,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static Asset_Detail_UPDATE: Permission = {
    PermissionKey: PermissionKeys.AssetCalibration,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static Asset_Detail_DELETE: Permission = {
    PermissionKey: PermissionKeys.AssetCalibration,
    PermissionType: PermissionTypes.IsDelete,
  };

  //RMQC Quality Parameter Component 
  public static RMQC_QUALITY_PARAMETER_ACCESS: Permission = {
    PermissionKey: PermissionKeys.RMQCQualityParameters,
    PermissionType: PermissionTypes.IsRead,
  };
  public static RMQC_QUALITY_PARAMETER_CREATE: Permission = {
    PermissionKey: PermissionKeys.RMQCQualityParameters,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static RMQC_QUALITY_PARAMETER_UPDATE: Permission = {
    PermissionKey: PermissionKeys.RMQCQualityParameters,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static RMQC_QUALITY_PARAMETER_DELETE: Permission = {
    PermissionKey: PermissionKeys.RMQCQualityParameters,
    PermissionType: PermissionTypes.IsDelete,
  };

  //RMQC Quality Parameter Component 
  public static RMQC_ACCESS: Permission = {
    PermissionKey: PermissionKeys.RMQC,
    PermissionType: PermissionTypes.IsRead,
  };
  public static RMQC_CREATE: Permission = {
    PermissionKey: PermissionKeys.RMQC,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static RMQC_UPDATE: Permission = {
    PermissionKey: PermissionKeys.RMQC,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static RMQC_DELETE: Permission = {
    PermissionKey: PermissionKeys.RMQC,
    PermissionType: PermissionTypes.IsDelete,
  };


  //Batch Linking Component 
  public static BatchLinking_ACCESS: Permission = {
    PermissionKey: PermissionKeys.BatchLinking,
    PermissionType: PermissionTypes.IsRead,
  };
  public static BatchLinking_CREATE: Permission = {
    PermissionKey: PermissionKeys.BatchLinking,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static BatchLinking_UPDATE: Permission = {
    PermissionKey: PermissionKeys.BatchLinking,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static BatchLinking_DELETE: Permission = {
    PermissionKey: PermissionKeys.BatchLinking,
    PermissionType: PermissionTypes.IsDelete,
  };

  //Batch QC 
  public static BATCH_QC_PREPARATION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.BatchQCPrepration,
    PermissionType: PermissionTypes.IsRead,
  };
  public static BATCH_QC_PREPARATION_CREATE: Permission = {
    PermissionKey: PermissionKeys.BatchQCPrepration,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static BATCH_QC_PREPARATION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.BatchQCPrepration,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static BATCH_QC_PREPARATION_DELETE: Permission = {
    PermissionKey: PermissionKeys.BatchQCPrepration,
    PermissionType: PermissionTypes.IsDelete,
  };

  //Whatsapp Configuration 
  public static WHATSAPP_CONFIGURATION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.WhatsappConfiguration,
    PermissionType: PermissionTypes.IsRead,
  };
  public static WHATSAPP_CONFIGURATION_CREATE: Permission = {
    PermissionKey: PermissionKeys.WhatsappConfiguration,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static WHATSAPP_CONFIGURATION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.WhatsappConfiguration,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static WHATSAPP_CONFIGURATION_DELETE: Permission = {
    PermissionKey: PermissionKeys.WhatsappConfiguration,
    PermissionType: PermissionTypes.IsDelete,
  };

  //Whatsapp Configuration 
  public static MANAGE_MODULE_LICENSES_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ManageModuleLicenses,
    PermissionType: PermissionTypes.IsRead,
  };
  public static MANAGE_MODULE_LICENSES_CREATE: Permission = {
    PermissionKey: PermissionKeys.ManageModuleLicenses,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static MANAGE_MODULE_LICENSES_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ManageModuleLicenses,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static MANAGE_MODULE_LICENSES_DELETE: Permission = {
    PermissionKey: PermissionKeys.ManageModuleLicenses,
    PermissionType: PermissionTypes.IsDelete,
  };

  //PRODUCTIVITY MANAGEMENT MACHINE DASHBOARD  
  public static PRODUCTIVITY_MANAGEMENT_ACCESS: Permission = {
    PermissionKey: PermissionKeys.MachineDashboard,
    PermissionType: PermissionTypes.IsRead,
  };
  public static PRODUCTIVITY_MANAGEMENT_CREATE: Permission = {
    PermissionKey: PermissionKeys.MachineDashboard,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static PRODUCTIVITY_MANAGEMENT_UPDATE: Permission = {
    PermissionKey: PermissionKeys.MachineDashboard,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static PRODUCTIVITY_MANAGEMENT_DELETE: Permission = {
    PermissionKey: PermissionKeys.MachineDashboard,
    PermissionType: PermissionTypes.IsDelete,
  };

  //Task
  public static OLE_MASTER_ACCESS: Permission = {
    PermissionKey: PermissionKeys.OLEMasterData,
    PermissionType: PermissionTypes.IsRead,
  };
  public static OLE_MASTER_CREATE: Permission = {
    PermissionKey: PermissionKeys.OLEMasterData,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static OLE_MASTER_UPDATE: Permission = {
    PermissionKey: PermissionKeys.OLEMasterData,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static OLE_MASTER_DELETE: Permission = {
    PermissionKey: PermissionKeys.OLEMasterData,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Staff Attendance permissions
  public static STAFF_ATTENDANCE_ACCESS: Permission = {
    PermissionKey: PermissionKeys.StaffAttendence,
    PermissionType: PermissionTypes.IsRead,
  };
  public static STAFF_ATTENDANCE_CREATE: Permission = {
    PermissionKey: PermissionKeys.StaffAttendence,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static STAFF_ATTENDANCE_UPDATE: Permission = {
    PermissionKey: PermissionKeys.StaffAttendence,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static STAFF_ATTENDANCE_DELETE: Permission = {
    PermissionKey: PermissionKeys.StaffAttendence,
    PermissionType: PermissionTypes.IsDelete,
  };


  // FTE  Macro  Level permissions
  public static FTE_MACRO_LEVEL_ACCESS: Permission = {
    PermissionKey: PermissionKeys.FTEMicroLevel,
    PermissionType: PermissionTypes.IsRead,
  };
  public static FTE_MACRO_LEVEL_CREATE: Permission = {
    PermissionKey: PermissionKeys.FTEMicroLevel,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static FTE_MACRO_LEVEL_UPDATE: Permission = {
    PermissionKey: PermissionKeys.FTEMicroLevel,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static FTE_MACRO_LEVEL_DELETE: Permission = {
    PermissionKey: PermissionKeys.FTEMicroLevel,
    PermissionType: PermissionTypes.IsDelete,
  };

  // FTE  Macro  Level permissions
  public static EXECUTION_DETAIL_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ExecutionDetail,
    PermissionType: PermissionTypes.IsRead,
  };
  public static EXECUTION_DETAIL_CREATE: Permission = {
    PermissionKey: PermissionKeys.ExecutionDetail,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static EXECUTION_DETAIL_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ExecutionDetail,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static EXECUTION_DETAIL_DELETE: Permission = {
    PermissionKey: PermissionKeys.ExecutionDetail,
    PermissionType: PermissionTypes.IsDelete,
  };


  // Warehouse Received permissions
  public static Warehouse_Received_ACCESS: Permission = {
    PermissionKey: PermissionKeys.WarehouseReceived,
    PermissionType: PermissionTypes.IsRead,
  };
  public static Warehouse_Received_CREATE: Permission = {
    PermissionKey: PermissionKeys.WarehouseReceived,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static Warehouse_Received_UPDATE: Permission = {
    PermissionKey: PermissionKeys.WarehouseReceived,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static Warehouse_Received_DELETE: Permission = {
    PermissionKey: PermissionKeys.WarehouseReceived,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Pallet Box permissions
  public static Pallet_Box_ACCESS: Permission = {
    PermissionKey: PermissionKeys.PalletBox,
    PermissionType: PermissionTypes.IsRead,
  };
  public static Pallet_Box_CREATE: Permission = {
    PermissionKey: PermissionKeys.PalletBox,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static Pallet_Box_UPDATE: Permission = {
    PermissionKey: PermissionKeys.PalletBox,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static Pallet_Box_DELETE: Permission = {
    PermissionKey: PermissionKeys.PalletBox,
    PermissionType: PermissionTypes.IsDelete,
  };


  // Micro Level Dashboard permissions
  public static MICRO_LEVEL_DASHBOARD_ACCESS: Permission = {
    PermissionKey: PermissionKeys.MicroLevelDashboard,
    PermissionType: PermissionTypes.IsRead,
  };
  public static MICRO_LEVEL_DASHBOARD_CREATE: Permission = {
    PermissionKey: PermissionKeys.MicroLevelDashboard,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static MICRO_LEVEL_DASHBOARD_UPDATE: Permission = {
    PermissionKey: PermissionKeys.MicroLevelDashboard,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static MICRO_LEVEL_DASHBOARD_DELETE: Permission = {
    PermissionKey: PermissionKeys.MicroLevelDashboard,
    PermissionType: PermissionTypes.IsDelete,
  };

  // BATCH PREPARATION
  public static BATCH_PREPARATION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.BatchPreparation,
    PermissionType: PermissionTypes.IsRead,
  };
  public static BATCH_PREPARATION_CREATE: Permission = {
    PermissionKey: PermissionKeys.BatchPreparation,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static BATCH_PREPARATION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.BatchPreparation,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static BATCH_PREPARATION_DELETE: Permission = {
    PermissionKey: PermissionKeys.BatchPreparation,
    PermissionType: PermissionTypes.IsDelete,
  };

  // BATCH TIMING SHEET
  public static BATCH_TIMING_SHEET_ACCESS: Permission = {
    PermissionKey: PermissionKeys.BatchTimingSheet,
    PermissionType: PermissionTypes.IsRead,
  };
  public static BATCH_TIMING_SHEET_CREATE: Permission = {
    PermissionKey: PermissionKeys.BatchTimingSheet,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static BATCH_TIMING_SHEET_UPDATE: Permission = {
    PermissionKey: PermissionKeys.BatchTimingSheet,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static BATCH_TIMING_SHEET_DELETE: Permission = {
    PermissionKey: PermissionKeys.BatchTimingSheet,
    PermissionType: PermissionTypes.IsDelete,
  };

  // DOWNTIME REPORT
  public static DOWNTIME_REPORT_ACCESS: Permission = {
    PermissionKey: PermissionKeys.DowntimeReport,
    PermissionType: PermissionTypes.IsRead,
  };
  public static DOWNTIME_REPORT_CREATE: Permission = {
    PermissionKey: PermissionKeys.DowntimeReport,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static DOWNTIME_REPORT_UPDATE: Permission = {
    PermissionKey: PermissionKeys.DowntimeReport,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static DOWNTIME_REPORT_DELETE: Permission = {
    PermissionKey: PermissionKeys.DowntimeReport,
    PermissionType: PermissionTypes.IsDelete,
  };

  // PRODUCTION ORDER HONEY (/Home/Production-Order-Honey || Production Plan)
  public static PRODUCTION_ORDER_HONEY_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ProductionOrderHoney,
    PermissionType: PermissionTypes.IsRead,
  };
  public static PRODUCTION_ORDER_HONEY_CREATE: Permission = {
    PermissionKey: PermissionKeys.ProductionOrderHoney,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static PRODUCTION_ORDER_HONEY_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ProductionOrderHoney,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static PRODUCTION_ORDER_HONEY_DELETE: Permission = {
    PermissionKey: PermissionKeys.ProductionOrderHoney,
    PermissionType: PermissionTypes.IsDelete,
  };

  // PROCESSING TIME LOG SHEET
  public static PROCESSING_TIME_LOG_SHEET_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ProcessingTimeLogSheet,
    PermissionType: PermissionTypes.IsRead,
  };
  public static PROCESSING_TIME_LOG_SHEET_CREATE: Permission = {
    PermissionKey: PermissionKeys.ProcessingTimeLogSheet,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static PROCESSING_TIME_LOG_SHEET_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ProcessingTimeLogSheet,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static PROCESSING_TIME_LOG_SHEET_DELETE: Permission = {
    PermissionKey: PermissionKeys.ProcessingTimeLogSheet,
    PermissionType: PermissionTypes.IsDelete,
  };


  // FTE  Micro  Task permissions
  public static FTE_MICRO_TASK_ACCESS: Permission = {
    PermissionKey: PermissionKeys.FteMicroTask,
    PermissionType: PermissionTypes.IsRead,
  };
  public static FTE_MICRO_TASK_CREATE: Permission = {
    PermissionKey: PermissionKeys.FteMicroTask,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static FTE_MICRO_TASK_UPDATE: Permission = {
    PermissionKey: PermissionKeys.FteMicroTask,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static FTE_MICRO_TASK_DELETE: Permission = {
    PermissionKey: PermissionKeys.FteMicroTask,
    PermissionType: PermissionTypes.IsDelete,
  };

  // New SFDC Honey
  public static NEW_SFDC_HONEY_ACCESS: Permission = {
    PermissionKey: PermissionKeys.SFDCHoney,
    PermissionType: PermissionTypes.IsRead,
  };
  public static NEW_SFDC_HONEY_CREATE: Permission = {
    PermissionKey: PermissionKeys.SFDCHoney,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static NEW_SFDC_HONEY_UPDATE: Permission = {
    PermissionKey: PermissionKeys.SFDCHoney,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static NEW_SFDC_HONEY_DELETE: Permission = {
    PermissionKey: PermissionKeys.SFDCHoney,
    PermissionType: PermissionTypes.IsDelete,
  };

  // RawMaterialQualityChecks

  public static RAW_MATERIAL_QUAILTY_CHECKS_ACCESS: Permission = {
    PermissionKey: PermissionKeys.RawMaterialQualityChecks,
    PermissionType: PermissionTypes.IsRead,
  };
  public static RAW_MATERIAL_QUAILTY_CHECKS_CREATE: Permission = {
    PermissionKey: PermissionKeys.RawMaterialQualityChecks,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static RAW_MATERIAL_QUAILTY_CHECKS_UPDATE: Permission = {
    PermissionKey: PermissionKeys.RawMaterialQualityChecks,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static RAW_MATERIAL_QUAILTY_CHECKS_DELETE: Permission = {
    PermissionKey: PermissionKeys.RawMaterialQualityChecks,
    PermissionType: PermissionTypes.IsDelete,
  };

  // RMQC Parameter Approval Report

  public static RMQC_VERIFY_REPORT_ACCESS: Permission = {
    PermissionKey: PermissionKeys.RMQCVerifyReport,
    PermissionType: PermissionTypes.IsRead,
  };
  public static RMQC_VERIFY_REPORT_CREATE: Permission = {
    PermissionKey: PermissionKeys.RMQCVerifyReport,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static RMQC_VERIFY_REPORT_UPDATE: Permission = {
    PermissionKey: PermissionKeys.RMQCVerifyReport,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static RMQC_VERIFY_REPORT_DELETE: Permission = {
    PermissionKey: PermissionKeys.RMQCVerifyReport,
    PermissionType: PermissionTypes.IsDelete,
  };


  // Plant Model 

  public static PLANT_MODEL_ACCESS: Permission = {
    PermissionKey: PermissionKeys.PlantModel,
    PermissionType: PermissionTypes.IsRead,
  };
  public static PLANT_MODEL_CREATE: Permission = {
    PermissionKey: PermissionKeys.PlantModel,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static PLANT_MODEL_UPDATE: Permission = {
    PermissionKey: PermissionKeys.PlantModel,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static PLANT_MODEL_DELETE: Permission = {
    PermissionKey: PermissionKeys.PlantModel,
    PermissionType: PermissionTypes.IsDelete,
  };

  // MACHINE_PARAMETER
  public static MACHINE_PARAMETERS_ACCESS: Permission = {
    PermissionKey: PermissionKeys.MachineParameters,
    PermissionType: PermissionTypes.IsRead,
  };
  public static MACHINE_PARAMETERS_CREATE: Permission = {
    PermissionKey: PermissionKeys.MachineParameters,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static MACHINE_PARAMETERS_UPDATE: Permission = {
    PermissionKey: PermissionKeys.MachineParameters,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static MACHINE_PARAMETERS_DELETE: Permission = {
    PermissionKey: PermissionKeys.MachineParameters,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Asset Master Data
  public static ASSET_MASTER_DATA_ACCESS: Permission = {
    PermissionKey: PermissionKeys.AssetMasterData,
    PermissionType: PermissionTypes.IsRead,
  };
  public static ASSET_MASTER_DATA_CREATE: Permission = {
    PermissionKey: PermissionKeys.AssetMasterData,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static ASSET_MASTER_DATA_UPDATE: Permission = {
    PermissionKey: PermissionKeys.AssetMasterData,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static ASSET_MASTER_DATA_DELETE: Permission = {
    PermissionKey: PermissionKeys.AssetMasterData,
    PermissionType: PermissionTypes.IsDelete,
  };


  // Shop Floor Data Honey
  public static SHOP_FLOOR_DATA_Honey_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ShopFloorDataHoney,
    PermissionType: PermissionTypes.IsRead,
  };
  public static SHOP_FLOOR_DATA_Honey_CREATE: Permission = {
    PermissionKey: PermissionKeys.ShopFloorDataHoney,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static SHOP_FLOOR_DATA_Honey_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ShopFloorDataHoney,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static SHOP_FLOOR_DATA_Honey_DELETE: Permission = {
    PermissionKey: PermissionKeys.ShopFloorDataHoney,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Machine Parameter SPC
  public static MACHINE_PARAMETER_SPC_ACCESS: Permission = {
    PermissionKey: PermissionKeys.MachineParameterSPC,
    PermissionType: PermissionTypes.IsRead,
  };
  public static MACHINE_PARAMETER_SPC_CREATE: Permission = {
    PermissionKey: PermissionKeys.MachineParameterSPC,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static MACHINE_PARAMETER_SPC_UPDATE: Permission = {
    PermissionKey: PermissionKeys.MachineParameterSPC,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static MACHINE_PARAMETER_SPC_DELETE: Permission = {
    PermissionKey: PermissionKeys.MachineParameterSPC,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Production Report
  public static PRODUCTION_REPORT_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ProductionReport,
    PermissionType: PermissionTypes.IsRead,
  };
  public static PRODUCTION_REPORT_CREATE: Permission = {
    PermissionKey: PermissionKeys.ProductionReport,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static PRODUCTION_REPORT_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ProductionReport,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static PRODUCTION_REPORT_DELETE: Permission = {
    PermissionKey: PermissionKeys.ProductionReport,
    PermissionType: PermissionTypes.IsDelete,
  };


  //Quality Parameter SPC
  public static QUALITY_PARAMETER_SPC_ACCESS: Permission = {
    PermissionKey: PermissionKeys.QualityParameterSPC,
    PermissionType: PermissionTypes.IsRead,
  };
  public static QUALITY_PARAMETER_SPC_CREATE: Permission = {
    PermissionKey: PermissionKeys.QualityParameterSPC,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static QUALITY_PARAMETER_SPC_UPDATE: Permission = {
    PermissionKey: PermissionKeys.QualityParameterSPC,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static QUALITY_PARAMETER_SPC_DELETE: Permission = {
    PermissionKey: PermissionKeys.QualityParameterSPC,
    PermissionType: PermissionTypes.IsDelete,
  };


  // Parameter Analysis Dashboard SPC
  public static PARAMETER_ANALYSIS_DASHBOARD_SPC_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ParameterAnalysisDashboardSPC,
    PermissionType: PermissionTypes.IsRead,
  };
  public static PARAMETER_ANALYSIS_DASHBOARD_SPC_CREATE: Permission = {
    PermissionKey: PermissionKeys.ParameterAnalysisDashboardSPC,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static PARAMETER_ANALYSIS_DASHBOARD_SPC_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ParameterAnalysisDashboardSPC,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static PARAMETER_ANALYSIS_DASHBOARD_SPC_DELETE: Permission = {
    PermissionKey: PermissionKeys.ParameterAnalysisDashboardSPC,
    PermissionType: PermissionTypes.IsDelete,
  };

  //RMQC Quality Parameter Logging 
  public static RMQC_QUALITY_PARAMETER_LOGGING_ACCESS: Permission = {
    PermissionKey: PermissionKeys.RawMaterialQualityChecksLogging,
    PermissionType: PermissionTypes.IsRead,
  };
  public static RMQC_QUALITY_PARAMETER_LOGGING_CREATE: Permission = {
    PermissionKey: PermissionKeys.RawMaterialQualityChecksLogging,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static RMQC_QUALITY_PARAMETER_LOGGING_UPDATE: Permission = {
    PermissionKey: PermissionKeys.RawMaterialQualityChecksLogging,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static RMQC_QUALITY_PARAMETER_LOGGING_DELETE: Permission = {
    PermissionKey: PermissionKeys.RawMaterialQualityChecksLogging,
    PermissionType: PermissionTypes.IsDelete,
  };

  //ERP Integration Status
  public static ERP_INTEGRATION_STATUS_ACCESS: Permission = {
    PermissionKey: PermissionKeys.ERPIntegrationStatus,
    PermissionType: PermissionTypes.IsRead,
  };
  public static ERP_INTEGRATION_STATUS_CREATE: Permission = {
    PermissionKey: PermissionKeys.ERPIntegrationStatus,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static ERP_INTEGRATION_STATUS_UPDATE: Permission = {
    PermissionKey: PermissionKeys.ERPIntegrationStatus,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static ERP_INTEGRATION_STATUS_DELETE: Permission = {
    PermissionKey: PermissionKeys.ERPIntegrationStatus,
    PermissionType: PermissionTypes.IsDelete,
  };

  //iot console screen
  public static GOLDEN_BATCH_ANALYSIS_ACCESS: Permission = {
    PermissionKey: PermissionKeys.GoldenBatchAnalysis,
    PermissionType: PermissionTypes.IsRead,
  };
  public static GOLDEN_BATCH_ANALYSIS_CREATE: Permission = {
    PermissionKey: PermissionKeys.GoldenBatchAnalysis,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static GOLDEN_BATCH_ANALYSIS_UPDATE: Permission = {
    PermissionKey: PermissionKeys.GoldenBatchAnalysis,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static GOLDEN_BATCH_ANALYSIS_DELETE: Permission = {
    PermissionKey: PermissionKeys.GoldenBatchAnalysis,
    PermissionType: PermissionTypes.IsDelete,
  };

  public static DYNAMIC_DASHBOARD_ACCESS: Permission = {
    PermissionKey: PermissionKeys.CustomizedDashboard,
    PermissionType: PermissionTypes.IsRead,
  };
  public static DYNAMIC_DASHBOARD_CREATE: Permission = {
    PermissionKey: PermissionKeys.CustomizedDashboard,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static DYNAMIC_DASHBOARD_UPDATE: Permission = {
    PermissionKey: PermissionKeys.CustomizedDashboard,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static DYNAMIC_DASHBOARD_DELETE: Permission = {
    PermissionKey: PermissionKeys.CustomizedDashboard,
    PermissionType: PermissionTypes.IsDelete,
  };


  // Customer Survey Permissions
  public static CUSTOMER_SURVEY_ACCESS: Permission = {
    PermissionKey: PermissionKeys.CustomerSurvey,
    PermissionType: PermissionTypes.IsRead,
  };
  public static CUSTOMER_SURVEY_CREATE: Permission = {
    PermissionKey: PermissionKeys.CustomerSurvey,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static CUSTOMER_SURVEY_UPDATE: Permission = {
    PermissionKey: PermissionKeys.CustomerSurvey,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static CUSTOMER_SURVEY_DELETE: Permission = {
    PermissionKey: PermissionKeys.CustomerSurvey,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Machine Map SCREEN

  public static Machine_Map_ACCESS: Permission = {
    PermissionKey: PermissionKeys.MachineMap,
    PermissionType: PermissionTypes.IsRead,
  };
  public static Machine_Map_CREATE: Permission = {
    PermissionKey: PermissionKeys.MachineMap,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static Machine_Map_UPDATE: Permission = {
    PermissionKey: PermissionKeys.MachineMap,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static Machine_Map_DELETE: Permission = {
    PermissionKey: PermissionKeys.MachineMap,
    PermissionType: PermissionTypes.IsDelete,
  };

  //QUALITY CONTROL DEPARTMENT ( /Home/Quality-control-department )
  public static QUALITY_CONTROL_DEPARTMENT_ACCESS: Permission = {
    PermissionKey: PermissionKeys.QualityControlDepartment,
    PermissionType: PermissionTypes.IsRead,
  };

  //QUALITY CONTROL DEPARTMENT ( /Home/KPItargetdownload )
  public static KPI_TARGET_DOWNLOAD_ACCESS: Permission = {
    PermissionKey: PermissionKeys.KPITargetDownload,
    PermissionType: PermissionTypes.IsRead,
  };

  //ADMIN DASHBOARD (Dashboard/AdminDashboard);
  public static ADMIN_DASHBOARD_ACCESS: Permission = {
    PermissionKey: PermissionKeys.AdminDashboard,
    PermissionType: PermissionTypes.IsRead,
  };
  public static ADMIN_DASHBOARD_CREATE: Permission = {
    PermissionKey: PermissionKeys.AdminDashboard,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static ADMIN_DASHBOARD_UPDATE: Permission = {
    PermissionKey: PermissionKeys.AdminDashboard,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static ADMIN_DASHBOARD_DELETE: Permission = {
    PermissionKey: PermissionKeys.AdminDashboard,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Event Configuration SCREEN

  public static EVENT_CONFIGURATION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.EventConfiguration,
    PermissionType: PermissionTypes.IsRead,
  };
  public static EVENT_CONFIGURATION_CREATE: Permission = {
    PermissionKey: PermissionKeys.EventConfiguration,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static EVENT_CONFIGURATION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.EventConfiguration,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static EVENT_CONFIGURATION_DELETE: Permission = {
    PermissionKey: PermissionKeys.EventConfiguration,
    PermissionType: PermissionTypes.IsDelete,
  };

  // LotCode/Pallet Print SCREEN

  public static LOTCODE_PALLET_PRINT_ACCESS: Permission = {
    PermissionKey: PermissionKeys.LotCodePalletPrint,
    PermissionType: PermissionTypes.IsRead,
  };
  public static LOTCODE_PALLET_PRINT_CREATE: Permission = {
    PermissionKey: PermissionKeys.LotCodePalletPrint,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static LOTCODE_PALLET_PRINT_UPDATE: Permission = {
    PermissionKey: PermissionKeys.LotCodePalletPrint,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static LOTCODE_PALLET_PRINT_DELETE: Permission = {
    PermissionKey: PermissionKeys.LotCodePalletPrint,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Batch Flow Configuration Component

  public static BATCHFLOW_CONFIGURATION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.batchFlowConfiguration,
    PermissionType: PermissionTypes.IsRead,
  };
  public static BATCHFLOW_CONFIGURATION_CREATE: Permission = {
    PermissionKey: PermissionKeys.batchFlowConfiguration,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static BATCHFLOW_CONFIGURATION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.batchFlowConfiguration,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static BATCHFLOW_CONFIGURATION_DELETE: Permission = {
    PermissionKey: PermissionKeys.batchFlowConfiguration,
    PermissionType: PermissionTypes.IsDelete,
  };

  // NCR Skip Window Component

  public static NCR_SKIP_WINDOW_ACCESS: Permission = {
    PermissionKey: PermissionKeys.NCRSkipWindow,
    PermissionType: PermissionTypes.IsRead,
  };
  public static NCR_SKIP_WINDOW_CREATE: Permission = {
    PermissionKey: PermissionKeys.NCRSkipWindow,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static NCR_SKIP_WINDOW_UPDATE: Permission = {
    PermissionKey: PermissionKeys.NCRSkipWindow,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static NCR_SKIP_WINDOW_DELETE: Permission = {
    PermissionKey: PermissionKeys.NCRSkipWindow,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Data EXtraction Component

  public static DATA_EXTRACTION_ACCESS: Permission = {
    PermissionKey: PermissionKeys.DataExtraction,
    PermissionType: PermissionTypes.IsRead,
  };
  public static DATA_EXTRACTION_CREATE: Permission = {
    PermissionKey: PermissionKeys.DataExtraction,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static DATA_EXTRACTION_UPDATE: Permission = {
    PermissionKey: PermissionKeys.DataExtraction,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static DATA_EXTRACTION_DELETE: Permission = {
    PermissionKey: PermissionKeys.DataExtraction,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Page Count Dashboard Component

  public static PAGE_COUNT_DASHBOARD_ACCESS: Permission = {
    PermissionKey: PermissionKeys.PageCountdasshboard,
    PermissionType: PermissionTypes.IsRead,
  };
  public static PAGE_COUNT_DASHBOARD_CREATE: Permission = {
    PermissionKey: PermissionKeys.PageCountdasshboard,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static PAGE_COUNT_DASHBOARD_UPDATE: Permission = {
    PermissionKey: PermissionKeys.PageCountdasshboard,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static PAGE_COUNT_DASHBOARD_DELETE: Permission = {
    PermissionKey: PermissionKeys.PageCountdasshboard,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Warehouse Component

  public static WAREHOUSE_ACCESS: Permission = {
    PermissionKey: PermissionKeys.Warehouse,
    PermissionType: PermissionTypes.IsRead,
  };
  public static WAREHOUSE_CREATE: Permission = {
    PermissionKey: PermissionKeys.Warehouse,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static WAREHOUSE_UPDATE: Permission = {
    PermissionKey: PermissionKeys.Warehouse,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static WAREHOUSE_DELETE: Permission = {
    PermissionKey: PermissionKeys.Warehouse,
    PermissionType: PermissionTypes.IsDelete,
  };

  // CoEDashboard
  public static COE_DashBoard_ACCESS: Permission = {
    PermissionKey: PermissionKeys.Coedashboard,
    PermissionType: PermissionTypes.IsRead,
  };
  public static COE_DashBoard_CREATE: Permission = {
    PermissionKey: PermissionKeys.Coedashboard,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static COE_DashBoard_UPDATE: Permission = {
    PermissionKey: PermissionKeys.Coedashboard,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static COE_DashBoard_DELETE: Permission = {
    PermissionKey: PermissionKeys.Coedashboard,
    PermissionType: PermissionTypes.IsDelete,
  };


   // Sampling Window
   public static SamplingWindow_Access: Permission = {
    PermissionKey: PermissionKeys.SamplingWindow,
    PermissionType: PermissionTypes.IsRead,
  };
  public static SamplingWindow_Create: Permission = {
    PermissionKey: PermissionKeys.SamplingWindow,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static SamplingWindow_Update: Permission = {
    PermissionKey: PermissionKeys.SamplingWindow,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static SamplingWindow_Delete: Permission = {
    PermissionKey: PermissionKeys.SamplingWindow,
    PermissionType: PermissionTypes.IsDelete,
  };

  // Operator Execution Window
  public static OPERATOR_EXECUTION_WINDOW_ACCESS: Permission = {
    PermissionKey: PermissionKeys.OperatorExecutionWindow,
    PermissionType: PermissionTypes.IsRead,
  };
  public static OPERATOR_EXECUTION_WINDOW_CREATE: Permission = {
    PermissionKey: PermissionKeys.OperatorExecutionWindow,
    PermissionType: PermissionTypes.IsWrite,
  };
  public static OPERATOR_EXECUTION_WINDOW_UPDATE: Permission = {
    PermissionKey: PermissionKeys.OperatorExecutionWindow,
    PermissionType: PermissionTypes.IsUpdate,
  };
  public static OPERATOR_EXECUTION_WINDOW_DELETE: Permission = {
    PermissionKey: PermissionKeys.OperatorExecutionWindow,
    PermissionType: PermissionTypes.IsDelete,
  };

}
